import {
  BlockNodes,
  DEFAULT_EXTENSIONS,
  isNodeSchema,
  NodeSchema,
} from '@principle-theorem/editor';
import { EmailMessage } from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import { generateJSON } from '@tiptap/core';
import { Image } from '@tiptap/extension-image';
import { type EditorPresetsService } from '../editor/editor-presets.service';

export function buildEmailContent(
  email: WithRef<EmailMessage>,
  editorPresets: EditorPresetsService
): string | NodeSchema<BlockNodes>[] {
  const extensions = [
    ...editorPresets.defaultToHTMLExtensions(),
    ...DEFAULT_EXTENSIONS,
    Image.configure({
      inline: true,
    }),
  ];

  const schema = generateJSON(
    `<strong>Subject:</strong> ${
      email.subject
    }<br/> <strong>Body:</strong><br/> ${email.html || email.text}`,
    extensions
  ) as NodeSchema<BlockNodes>;

  if (!isNodeSchema(schema)) {
    return '';
  }

  return schema.content as NodeSchema<BlockNodes>[];
}
